import React from 'react'

import { Button, Modal } from 'antd'
import { getHighlightedText, useFormatMessage } from 'helpers/intl'
import { usePricingSchemasTranslation } from 'hooks/translation/usePricingSchemaTranslation'
import timeBasedLoiteringImage from 'assets/images/time-based-loitering-info.png'
import parkingFeeLoiteringImage from 'assets/images/parking-fee-loitering-info.png'
import statusBasedLoiteringImage from 'assets/images/status-based-loitering-info.png'
import { useAppState } from 'state'

interface props {
  visible: boolean
  onClose: () => void
}

interface LoiteringInfoBlock {
  description?: string
  highlightedText?: string
  image?: string
  sectionStart?: boolean
}

export const LoiteringInfoModal: React.FC<props> = ({ visible, onClose }) => {
  const {
    loiteringInfoP1Text,
    loiteringInfoP2Text,
    loiteringInfoP3Text,
    loiteringInfoP4Text,
    loiteringInfoP4aText,
    loiteringInfoP4bText,
    loiteringInfoP5Text,
    loiteringInfoP6Text,
    loiteringInfoP7Text,
  } = usePricingSchemasTranslation()

  const { language } = useAppState()

  const loiteringTitle = useFormatMessage('dashboard.text.loitering', 'Loitering')
  const gotItText = useFormatMessage(
    'dashboard.tenantPage.pricingSchemaTab.loiteringInfo.gotIt',
    'Got it',
  )

  const loiteringInfo: LoiteringInfoBlock[] = [
    {
      description: loiteringInfoP1Text,
    },
    {
      description: loiteringInfoP2Text,
      highlightedText: language === 'en' ? '1. Time-Based Loitering' : '1. Stationnement prolongé basé sur le temps',
    },
    {
      description: loiteringInfoP3Text,
    },
    {
      description: loiteringInfoP4Text,
    },
    {
      description: loiteringInfoP5Text,
    },
    {
      image: timeBasedLoiteringImage,
    },
    {
      description: loiteringInfoP4aText,
      highlightedText:
        language === 'en' ? 'Parking Fee (Time-Based Loitering)' : 'Frais de stationnement (stationnement prolongé basé sur le temps)',
      sectionStart: true,
    },
    {
      description: loiteringInfoP4bText,
    },
    {
      image: parkingFeeLoiteringImage,
    },
    {
      description: loiteringInfoP5Text,
      highlightedText: language === 'en' ? 'Status-based Loitering' : 'Loitering basé sur le statut',
      sectionStart: true,
    },
    {
      description: loiteringInfoP6Text,
      highlightedText: language === 'en' ? '2. Status-Based Loitering' : '2. Stationnement prolongé basé sur le statut',
    },
    {
      description: loiteringInfoP7Text,
    },
    {
      image: statusBasedLoiteringImage,
    },
  ]

  return (
    <Modal
      visible={visible}
      title={loiteringTitle}
      width="40%"
      footer={
        <Button type="primary" onClick={() => onClose()}>
          <span className="paragraph-02-regular">{gotItText}</span>
        </Button>
      }
      className="ghg-calcuation-modal loitering-info-modal"
      onCancel={onClose}
    >
      {loiteringInfo.map((item, index) => (
        <div
          key={index}
          className={`loitering-info-modal__block${item.sectionStart ? ' loitering-info-modal__block--section-start' : ''}${index === 0 ? ' loitering-info-modal__block--intro' : ''}`}
        >
          {item.description && (
            <p className="paragraph-01-regular loitering-info-modal__text">
              {getHighlightedText(item.description, item?.highlightedText, 'paragraph-01-bold')}
            </p>
          )}
          {item.image && (
            <img
              src={item.image}
              alt={`loitering-info-${index}`}
              className="loitering-info-modal__img"
            />
          )}
        </div>
      ))}
    </Modal>
  )
}

export default LoiteringInfoModal
